<template>
  <v-app id="portal">
    <v-content class="px-3">
      <titulo-responsivo :titulo="locale[local].screen.pip.string001" />
      <!-- <v-divider /> -->
      <v-card>
        <v-data-table
          fixed-header
          disable-pagination
          hide-default-footer
          :items="dados"
          :headers="headers"
          hide-default-header
          dense
        >
          <template v-slot:header="{ props }">
            <thead>
              <tr>
                <th
                  v-for="(header, headerKey) in props.headers"
                  :key="headerKey"
                  class="text-center"
                  style="font-size: 11px"
                >
                  <!--v-icon small>arrow_upward</v-icon-->

                  <h3>{{ header.text }}</h3>
                  <!-- <span v-if="headerKey !== 0">{{
                          getDay(header.titulo)
                        }}</span> -->
                </th>
              </tr>
            </thead>
          </template>

          <template v-slot:body="{ items }">
            <tbody>
              <tr
                class="black--text"
                v-for="(item, i) in items"
                :key="i"
              >
                <td style="cursor: pointer">
                  <h5 class="pa-0">
                    {{ item.tipo }}
                  </h5>
                </td>
                <td style="cursor: pointer">
                  <h5 class="pa-0">
                    {{ item.titulo }}
                  </h5>
                </td>
                <td style="cursor: pointer">
                  <h5 class="pa-0">
                    {{ item["1"] }}
                    <v-icon
                      @click="getDetalhes(item, 1)"
                      small
                      color="red"
                      v-if="item['1'] && item.cod_tipo"
                    >mdi-plus</v-icon>
                  </h5>
                </td>
                <td style="cursor: pointer">
                  <h5 class="pa-0">
                    {{ item["2"] }}
                    <v-icon
                      @click="getDetalhes(item, 2)"
                      small
                      color="red"
                      v-if="item['2'] && item.cod_tipo"
                    >mdi-plus</v-icon>
                  </h5>
                </td>
                <td style="cursor: pointer">
                  <h5 class="pa-0">
                    {{ item["3"] }}
                    <v-icon
                      @click="getDetalhes(item, 3)"
                      small
                      color="red"
                      v-if="item['3'] && item.cod_tipo"
                    >mdi-plus</v-icon>
                  </h5>
                </td>
                <td style="cursor: pointer">
                  <h5 class="pa-0">
                    {{ item["4"] }}
                    <v-icon
                      @click="getDetalhes(item, 4)"
                      small
                      color="red"
                      v-if="item['4'] && item.cod_tipo"
                    >mdi-plus</v-icon>
                  </h5>
                </td>
                <td style="cursor: pointer">
                  <h5 class="pa-0">
                    {{ item["5"] }}
                    <v-icon
                      @click="getDetalhes(item, 5)"
                      small
                      color="red"
                      v-if="item['5'] && item.cod_tipo"
                    >mdi-plus</v-icon>
                  </h5>
                </td>
                <td style="cursor: pointer">
                  <h5 class="pa-0">
                    {{ item["6"] }}
                    <v-icon
                      @click="getDetalhes(item, 6)"
                      small
                      color="red"
                      v-if="item['6'] && item.cod_tipo"
                    >mdi-plus</v-icon>
                  </h5>
                </td>
                <td style="cursor: pointer">
                  <h5 class="pa-0">
                    {{ item["7"] }}
                    <v-icon
                      @click="getDetalhes(item, 7)"
                      small
                      color="red"
                      v-if="item['7'] && item.cod_tipo"
                    >mdi-plus</v-icon>
                  </h5>
                </td>
                <td style="cursor: pointer">
                  <h5 class="pa-0">
                    {{ item["8"] }}
                    <v-icon
                      @click="getDetalhes(item, 8)"
                      small
                      color="red"
                      v-if="item['8'] && item.cod_tipo"
                    >mdi-plus</v-icon>
                  </h5>
                </td>
                <td style="cursor: pointer">
                  <h5 class="pa-0">
                    {{ item["9"] }}
                    <v-icon
                      @click="getDetalhes(item, 9)"
                      small
                      color="red"
                      v-if="item['9'] && item.cod_tipo"
                    >mdi-plus</v-icon>
                  </h5>
                </td>
                <td style="cursor: pointer">
                  <h5 class="pa-0">
                    {{ item["10"] }}
                    <v-icon
                      @click="getDetalhes(item, 10)"
                      small
                      color="red"
                      v-if="item['10'] && item.cod_tipo"
                    >mdi-plus</v-icon>
                  </h5>
                </td>
                <td style="cursor: pointer">
                  <h5 class="pa-0">
                    {{ item["11"] }}
                    <v-icon
                      @click="getDetalhes(item, 11)"
                      small
                      color="red"
                      v-if="item['11'] && item.cod_tipo"
                    >mdi-plus</v-icon>
                  </h5>
                </td>
                <td style="cursor: pointer">
                  <h5 class="pa-0">
                    {{ item["12"] }}
                    <v-icon
                      @click="getDetalhes(item, 12)"
                      small
                      color="red"
                      v-if="item['12'] && item.cod_tipo"
                    >mdi-plus</v-icon>
                  </h5>
                </td>
                <td style="cursor: pointer">
                  <h5 class="pa-0">
                    {{ item.media }}
                  </h5>
                </td>
                <td style="cursor: pointer">
                  <h5 class="pa-0">
                    {{ item.final }}
                  </h5>
                </td>
              </tr>
            </tbody>
          </template>

          <!-- <template v-slot:top>
            <v-app-bar flat color="transparent">
              <v-container fluid grid-list-md>
                <v-layout class="mt-6">
                  <v-flex offset-lg4 offset-md3 xs12 sm12 lg2 md3>
                    <cgi-data-picker
                      v-model="dataInicial"
                      label="Data Inicial"
                    ></cgi-data-picker>
                  </v-flex>
                  <v-flex xs12 sm12 lg2 md3>
                    <cgi-data-picker
                      v-model="dataFinal"
                      label="Data Final"
                    ></cgi-data-picker>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-app-bar>
          </template> -->

          <!-- <template v-slot:[`item.dtMovto`]="{ item }">
            {{ moment(item.dtMovto).format("DD/MM/YYYY") }}
          </template> -->
        </v-data-table>
      </v-card>
    </v-content>

    <v-dialog
      scrollable
      v-model="dialog"
      fullscreen
    >
      <v-card>
        <v-card-title>
          {{ locale[local].screen.pip.string002 }}
          <v-spacer></v-spacer>
          <v-icon @click="dialog = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-text>
          <v-data-table
            hide-default-footer
            disable-pagination
            dense
            :headers="headersDetalhes"
            :items="detalhes"
            sort-by="dtOcorrencia"
            sort-desc
          >
            <template v-slot:[`item.dtHrAtualizacao`]="{ item }">
              {{
                moment(item.dtHrAtualizacao, "YYYY-MM-DDTHH:mm:ss").format(
                  "DD/MM/YYYY HH:mm"
                )
              }}
            </template>
            <template v-slot:[`item.dtOcorrencia`]="{ item }">
              {{ moment(item.dtOcorrencia, "YYYY-MM-DD").format("DD/MM/YYYY") }}
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Service from "@/components/api/Service";
import moment from "moment";
import { locale } from '../locale/locale';
export default {
  data: () => ({
    // buscaIndicaPip
    // ttIndicaPipDetalhe
    dialog: false,
    headers: [
      {
        text: "",
        align: "left",
        sortable: false,
        value: "tipo",
      },
      {
        text: "",
        align: "left",
        sortable: false,
        value: "titulo",
      },
      {
        text: locale[window.local].screen.pip.string003, 
        align: "center",
        sortable: false,
        value: "1",
      },
      {
        text: locale[window.local].screen.pip.string004, 
        align: "center",
        sortable: false,
        value: "2",
      },
      {
        text: locale[window.local].screen.pip.string005, 
        align: "center",
        sortable: false,
        value: "3",
      },
      {
        text: locale[window.local].screen.pip.string006, 
        align: "center",
        sortable: false,
        value: "4",
      },
      {
        text: locale[window.local].screen.pip.string007, 
        align: "center",
        sortable: false,
        value: "5",
      },
      {
        text: locale[window.local].screen.pip.string008, 
        align: "center",
        sortable: false,
        value: "6",
      },
      {
        text: locale[window.local].screen.pip.string009, 
        align: "center",
        sortable: false,
        value: "7",
      },
      {
        text: locale[window.local].screen.pip.string010, 
        align: "center",
        sortable: false,
        value: "8",
      },
      {
        text: locale[window.local].screen.pip.string011, 
        align: "center",
        sortable: false,
        value: "9",
      },
      {
        text: locale[window.local].screen.pip.string012, 
        align: "center",
        sortable: false,
        value: "10",
      },
      {
        text: locale[window.local].screen.pip.string013, 
        align: "center",
        sortable: false,
        value: "11",
      },
      {
        text: locale[window.local].screen.pip.string014, 
        align: "center",
        sortable: false,
        value: "12",
      },
      {
        text: locale[window.local].screen.pip.string015, 
        align: "center",
        sortable: false,
        value: "media",
      },
      {
        text: locale[window.local].screen.pip.string016, 
        align: "center",
        sortable: false,
        value: "final",
      },
    ],
    headersDetalhes: [
      {
        text: locale[window.local].screen.pip.string017, 
        align: "left",
        sortable: false,
        value: "dtOcorrencia",
      },
      {
        text: locale[window.local].screen.pip.string018, 
        align: "left",
        sortable: false,
        value: "quantidade",
      },
    ],
    service: new Service(),
    loading: false,
    dados: [],
    dadosApi: [],
    dataInicial: moment().startOf("month").format("DD/MM/YYYY"),
    dataFinal: moment().endOf("month").format("DD/MM/YYYY"),
    detalhes: [],
  }),
  mounted() {
    this.getObservacao();
  },
  methods: {
    async getObservacao() {
      this.loading = true;

      try {
        const resposta = await this.service.buscaIndicaPip();

        if (resposta.status === 200) {
          if (resposta.data.retorno) {
            if (resposta.data.retorno[0].estatus === "Erro") {
              throw new Error(resposta.data.retorno[0].msgErro);
            }
          }

          const dados = resposta?.data?.indicaPip?.ttIndicaPip ?? [];

          this.dadosApi = resposta?.data?.indicaPip?.ttIndicaPip;

          const tipos1 = dados.filter((pip) => pip.tipo === 1);
          const tipos2 = dados.filter((pip) => pip.tipo === 2);
          const tipos3 = dados.filter((pip) => pip.tipo === 3);

          const tiposObj10 = {
            cod_tipo: 1,
            tipo: "ASSIDUIDADE",
            titulo: "Número Faltas",
            quantidade: tipos1[0].quantidade,
            1: tipos1[0].quantidade,
            2: tipos1[1].quantidade,
            3: tipos1[2].quantidade,
            4: tipos1[3].quantidade,
            5: tipos1[4].quantidade,
            6: tipos1[5].quantidade,
            7: tipos1[6].quantidade,
            8: tipos1[7].quantidade,
            9: tipos1[8].quantidade,
            10: tipos1[9].quantidade,
            11: tipos1[10].quantidade,
            12: tipos1[11].quantidade,
          };

          const tiposObj11 = {
            cod_tipo: null,
            tipo: "",
            titulo: "Nota Faltas",
            quantidade: tipos1[0].quantidade,
            1: `${tipos1[0].nota} %`,
            2: `${tipos1[1].nota} %`,
            3: `${tipos1[2].nota} %`,
            4: `${tipos1[3].nota} %`,
            5: `${tipos1[4].nota} %`,
            6: `${tipos1[5].nota} %`,
            7: `${tipos1[6].nota} %`,
            8: `${tipos1[7].nota} %`,
            9: `${tipos1[8].nota} %`,
            10: `${tipos1[9].nota} %`,
            11: `${tipos1[10].nota} %`,
            12: `${tipos1[11].nota} %`,
          };

          let valor1 = 0;

          for (let i = 0; i < 12; i++) {
            valor1 += tipos1[i].nota;
          }

          tiposObj11["media"] = (valor1 / 12).toFixed(2) + " %";

          this.dados.push(tiposObj10);
          this.dados.push(tiposObj11);

          const tiposObj20 = {
            cod_tipo: 2,
            tipo: "PONTUALIDADE",
            titulo: "Minutos Atraso",
            quantidade: tipos2[0].quantidade,
            1: tipos2[0].quantidade,
            2: tipos2[1].quantidade,
            3: tipos2[2].quantidade,
            4: tipos2[3].quantidade,
            5: tipos2[4].quantidade,
            6: tipos2[5].quantidade,
            7: tipos2[6].quantidade,
            8: tipos2[7].quantidade,
            9: tipos2[8].quantidade,
            10: tipos2[9].quantidade,
            11: tipos2[10].quantidade,
            12: tipos2[11].quantidade,
          };

          const tiposObj21 = {
            cod_tipo: null,
            tipo: "",
            titulo: "Nota Atraso",
            quantidade: tipos2[0].quantidade,
            1: `${tipos2[0].nota} %`,
            2: `${tipos2[1].nota} %`,
            3: `${tipos2[2].nota} %`,
            4: `${tipos2[3].nota} %`,
            5: `${tipos2[4].nota} %`,
            6: `${tipos2[5].nota} %`,
            7: `${tipos2[6].nota} %`,
            8: `${tipos2[7].nota} %`,
            9: `${tipos2[8].nota} %`,
            10: `${tipos2[9].nota} %`,
            11: `${tipos2[10].nota} %`,
            12: `${tipos2[11].nota} %`,
          };

          let valor2 = 0;

          for (let i = 0; i < 12; i++) {
            valor2 += tipos2[i].nota;
          }

          tiposObj21["media"] = (valor2 / 12).toFixed(2) + " %";

          tiposObj21["final"] = `${
            parseFloat(tiposObj11.media) + parseFloat(tiposObj21.media)
          } %`;

          this.dados.push(tiposObj20);
          this.dados.push(tiposObj21);

          const tiposObj30 = {
            cod_tipo: 3,
            tipo: "ADV/SUSPENSÃO",
            titulo: "Número Adv/Susp",
            quantidade: tipos2[0].quantidade,
            1: tipos3[0].quantidade,
            2: tipos3[1].quantidade,
            3: tipos3[2].quantidade,
            4: tipos3[3].quantidade,
            5: tipos3[4].quantidade,
            6: tipos3[5].quantidade,
            7: tipos3[6].quantidade,
            8: tipos3[7].quantidade,
            9: tipos3[8].quantidade,
            10: tipos3[9].quantidade,
            11: tipos3[10].quantidade,
            12: tipos3[11].quantidade,
          };

          const tiposObj31 = {
            cod_tipo: null,
            tipo: "",
            titulo: "Sub-totais",
            quantidade: tipos2[0].quantidade,
            1:
              tipos1[0].nota + tipos2[0].nota === 100
                ? "130 %"
                : `${tipos1[0].nota + tipos2[0].nota} %`,
            2:
              tipos1[1].nota + tipos2[1].nota === 100
                ? "130 %"
                : `${tipos1[1].nota + tipos2[1].nota} %`,
            3:
              tipos1[2].nota + tipos2[2].nota === 100
                ? "130 %"
                : `${tipos1[2].nota + tipos2[2].nota} %`,
            4:
              tipos1[3].nota + tipos2[3].nota === 100
                ? "130 %"
                : `${tipos1[3].nota + tipos2[3].nota} %`,
            5:
              tipos1[4].nota + tipos2[4].nota === 100
                ? "130 %"
                : `${tipos1[4].nota + tipos2[4].nota} %`,
            6:
              tipos1[5].nota + tipos2[5].nota === 100
                ? "130 %"
                : `${tipos1[5].nota + tipos2[5].nota} %`,
            7:
              tipos1[6].nota + tipos2[6].nota === 100
                ? "130 %"
                : `${tipos1[6].nota + tipos2[6].nota} %`,
            8:
              tipos1[7].nota + tipos2[7].nota === 100
                ? "130 %"
                : `${tipos1[7].nota + tipos2[7].nota} %`,
            9:
              tipos1[8].nota + tipos2[8].nota === 100
                ? "130 %"
                : `${tipos1[8].nota + tipos2[8].nota} %`,
            10:
              tipos1[9].nota + tipos2[9].nota === 100
                ? "130 %"
                : `${tipos1[9].nota + tipos2[9].nota} %`,
            11:
              tipos1[10].nota + tipos2[10].nota === 100
                ? "130 %"
                : `${tipos1[10].nota + tipos2[10].nota} %`,
            12:
              tipos1[11].nota + tipos2[11].nota === 100
                ? "130 %"
                : `${tipos1[11].nota + tipos2[11].nota} %`,
          };

          let valor = 0;

          for (let i = 0; i < 12; i++) {
            valor +=
              tipos1[i].nota + tipos2[i].nota === 100
                ? 130
                : tipos1[i].nota + tipos2[i].nota;
          }

          tiposObj31["final"] = (valor / 12).toFixed(2) + " %";

          this.dados.push(tiposObj30);
          this.dados.push(tiposObj31);
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
        console.log(this.dados);
      }
    },
    getDetalhes(item, mes) {
      const detalhes = this.dadosApi.filter(
        (i) =>
          i.quantidade === item[mes] &&
          i.tipo === item.cod_tipo &&
          i.mes === mes
      );

      this.detalhes = detalhes[0].ttIndicaPipDetalhe;

      console.log(this.detalhes);

      this.dialog = true;
    },
  },
};
</script>

<style scoped>
.unread {
  background-color: lightgrey;
}

.unread_text {
  font-weight: bold;
}

.table-heigth {
  height: calc(100vh - 130px);
}
</style>
